/* eslint-disable import/prefer-default-export */
import loadjs from 'loadjs';
import isFunction from 'lodash/isFunction';

import { version } from '../../package.json';

export function loadVA(config, changedFilePaths) {
  loadjs([`${config.appFilePath}?ver=${version}`, ...changedFilePaths], {
    async: false,
    success() {
      const app = new window.VA(config);

      if (window.__va__.q && window.__va__.q.length) {
        window.__va__.q.forEach(callback => {
          if (isFunction(callback)) {
            callback(app);
          }
        });
      }

      app.render();
    },
    error(depsNotFound) {
      console.error('Next dependencies not found:', depsNotFound);
    },
    before(path, scriptEl) {
      scriptEl.crossOrigin = 'anonymous';
    }
  });
}
